import * as types from "./../../statics/actionConstants";

export const postAPIMessage = (Message) => ({
  type: types.API_MESSAGE,
  Message
});
export const postAPIDraft = (Draft) => ({
  type: types.API_DRAFT,
  Draft
});
export const postUserDraftUpdated = (Status) => ({
  type: types.USER_DRAFT_UPDATED,
  Status
});
export const postAPIMessagesReceived = (MessagesReceived) => ({
  type: types.API_MESSAGES_RECEIVED,
  MessagesReceived
});
export const postAPIMessages = (Messages) => ({
  type: types.API_MESSAGES,
  Messages
});
export const postAPIMessageSubjectCategory = (MessageSubjectCategory) => ({
  type: types.API_MESSAGE_SUBJECT_CATEGORY,
  MessageSubjectCategory
});
export const postAPIMessageBody = (MessageBody) => ({
  type: types.API_MESSAGE_BODY,
  MessageBody
});
export const postAPIEmployee = (Employee) => ({
  type: types.API_EMPLOYEE,
  Employee
});
export const postAPIMailboxes = (Mailboxes) => ({
  type: types.API_MAILBOXES,
  Mailboxes
});
export const postAPIMailbox = (Mailbox) => ({
  type: types.API_MAILBOX,
  Mailbox
});

export const postUserSettingsLocal = (Local) => ({
  type: types.USER_SETTINGS_LOCAL,
  Local
});
export const postUserSettingsGlobal = (Global) => ({
  type: types.USER_SETTINGS_GLOBAL,
  Global
});
export const postUserSettingsLocalSidebar = () => ({
  type: types.USER_SETTINGS_LOCAL_SIDEBAR
});
export const postUserSettingsGlobalFavoriteAccounts = (Accounts) => ({
  type: types.USER_SETTINGS_GLOBAL_FAVORITE_ACCOUNTS,
  Accounts
});
export const postUserSites = (Sites) => ({
  type: types.USER_SITES,
  Sites
});
export const postUserSettingsGlobalLastUsedSettings = (LastUsedSettings) => ({
  type: types.USER_SETTINGS_GLOBAL_LAST_USED_SETTINGS,
  LastUsedSettings: LastUsedSettings
});
export const postUserSettingsGlobalSidebar = () => ({
  type: types.USER_SETTINGS_GLOBAL_SIDEBAR
});
export const postUserSettingsLocalDrafts = (newDrafts) => ({
  type: types.USER_SETTINGS_LOCAL_DRAFTS,
  newDrafts
});
export const postUserPermissionsDetailed = (PermissionsDetailed) => ({
  type: types.USER_PERMISSIONS_DETAILED,
  PermissionsDetailed
});
